import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { sendAnalyticsOnTariffsBlockVisibility } from "../blocks/analytics";
import { useInView } from "./useInView";

// при смене таба тарифов срабатывает разметка на тарифные карточки в поле видимости
export var useViewportTariffsBlockAnalytics = function useViewportTariffsBlockAnalytics(ref, props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    isOnce = _useState2[0],
    setIsOnce = _useState2[1];
  var inView = useInView(ref, {
    threshold: 0.5
  });
  var commonAnalyticsData = props.commonAnalyticsData,
    elementTitle = props.elementTitle,
    tabName = props.tabName,
    blockTitle = props.blockTitle,
    pageType = props.pageType;
  useEffect(function () {
    if (!isOnce && inView && elementTitle) {
      sendAnalyticsOnTariffsBlockVisibility({
        pageType: pageType,
        blockTitle: blockTitle,
        commonAnalyticsData: commonAnalyticsData,
        elementTitle: elementTitle,
        tabName: tabName
      });
      setIsOnce(true);
    }
  }, [inView, tabName]);
};